export const partition = <T>(array: T[], predicate: (element: T) => boolean): [T[], T[]] => array.reduce(
  ([predicateTrue, predicateFalse], element) => {
    if (predicate(element)) {
      predicateTrue.push(element)
    } else {
      predicateFalse.push(element)
    }
    return [predicateTrue, predicateFalse]
  }, [[],[]]
)